import axios from 'axios'

const api = {
  http: axios.create({ baseURL: '/api/', timeout: 600000 }),
  fileHttp: null,
  clientAction: null,
  async send(method, ...args) {
    return this._send(this.http, method, ...args)
  },
  async sendFile(method, ...args) {
    return this.fileHttp === null ? this._send(this.http, method, ...args) : this._send(this.fileHttp, method, ...args)
  },
  async _send(http, method, ...args) {
    try {
      const response = await http[method](...args);
      if (response.data.clientAction && typeof this.clientAction === 'function')
        this.clientAction(response.data.clientAction)
      //console.log(method, ...args, response.data)
      return response.data
    } catch (error) {
      return { status: false, message: `Wystąpił błąd zapytania do serwera: ${error.message}`}
    }
  },
  async checkLogin () {
    return await this.send('post', '/auth/checkLogin')
  },
  async login (data) {
    return await this.send('post', '/auth/login', data)
  },
  async logout () {
    return await this.send('post', '/auth/logout')
  },
  async createFileHttp(url) {
    if (this.fileHttp !== null || !url) return
    this.fileHttp = axios.create({ baseURL: url, timeout: 600000 })
  },
}

export default api